import React, { createContext, useContext, useState, useEffect } from "react";

const Ctx = createContext({ dark: false, toggle: () => {}, count: 0 });

export function DarkModeProvider({ children }) {
  const [dark, setDark] = useState(() => {
    if (typeof window === "undefined") return false;
    const saved = localStorage.getItem("erpik-theme");
    if (saved) return saved === "dark";
    return window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false;
  });

  // count increments on every toggle — lets consumers react to the event
  const [count, setCount] = useState(0);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("erpik-theme", dark ? "dark" : "light");
  }, [dark]);

  const toggle = () => {
    setDark((v) => {
      window.posthog?.capture("theme_toggled", { theme: v ? "light" : "dark" });
      return !v;
    });
    setCount((c) => c + 1);
  };

  return (
    <Ctx.Provider value={{ dark, toggle, count }}>
      {children}
    </Ctx.Provider>
  );
}

export const useDarkMode = () => useContext(Ctx);
